export const CONTROLS_SHOW = 'CONTROLS_SHOW';
export const CONTROLS_HIDE = 'CONTROLS_HIDE';
